export const ICON_SIZES = {
  x2small: 1.0,
  xsmall: 1.2,
  small: 1.4,
  normal: 1.6,
  large: 1.8,
  larger: 2,
  xlarge: 2.2,
  xxlarge: 4,
};

export const ICON_WEIGHTS = {
  thin: 0.8,
  light: 1.2,
  regular: 1.6,
  bold: 2.4,
  fill: null,
  duotone: null,
};
